import React, { ReactNode } from "react";
import { StageStateBar, StateBar } from "components";
import { StageState, UpdateState } from "enums";
import { IStage, IUpdate } from "interfaces";

export function renderBar(update: IUpdate, stage: IStage): ReactNode {
    if (update.state < UpdateState.Running) {
        return <StateBar state={update.state} />
    } 

    // The bar looks weird with the running stage zebra strips background, so we're not showing it in that case.
    if (stage.state === StageState.Running) {
        return null;
    }

    return <StageStateBar state={stage.state} />
}